import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const hierarchyList = createAsyncThunk('hierarchyList', async ({ pageable: data, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: getConfig.API_URL + `hierarchy_list`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'premise_id': data?.premise_id || '',
                'zone_id': data?.zone_id || '',
                'level_id': data?.level_id || '',
                'unit_id': data?.unit_id || '',
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const hierarchyListSlice = createSlice({
    name: 'hierarchyList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(hierarchyList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }

        });
        builder.addCase(hierarchyList.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default hierarchyListSlice.reducer; 